$(document).ready(() => {
    // Mobile Nav
    $('.trigger-secondary').click(function() {
      $(this)
        .next()
        .fadeIn();
      $(this)
        .closest('.nav-menu')
        .addClass('secondary-open');
      $('.mobile-menu-footer').hide();
    });
    $('.close-secondary').click(function() {
      $(this)
        .closest('.secondary-links')
        .fadeOut();
      $(this)
        .closest('.nav-menu')
        .removeClass('secondary-open');
      $('.mobile-menu-footer').show();
    });
    $('.trigger-tertiary').click(function() {
        if ( $( this ).hasClass('submenu-open') ) {
            $(this)
              .removeClass('submenu-open');
            $(this)
              .next()
              .css("display", "none");
        } else {
            $(this)
              .addClass('submenu-open');
            $(this)
              .next()
              .fadeIn()
              .css("display", "flex");
        }
    });
    $('#menuToggle').click(() => {
        $('.mobile-menu').addClass('open');
        $('body').css('overflow-y', 'hidden');
    
    });
    $(".mobile-menu .close-menu").click(()=> {
        $(".mobile-menu").removeClass("open"), $(".mobile-menu-container").removeClass("open"), $("html").css("overflow", ""), $("body").css("overflow", "")
    });
  });